import React, { useState } from 'react';

// --- CONFIGURATION: EDIT YOUR TITLES HERE ---
const artworks = [
  { id: 1, title: "Sils Maria", year: "2025", style:"Van Gogh" },
  { id: 2, title: "Lady's Day in Ascot", year: "2025" , style:"Impressionism"},
  { id: 3, title: "Day in Knole", year: "2025" , style:"Hopper"},
  { id: 4, title: "Portrait of Natalia", year: "2025", style:"Warhol" },
  { id: 5, title: "Anna's Fairytale", year: "2025", style:"Classic Surrealism" },
  { id: 6, title: "Neighbourhood Watch", year: "2025", style:"Hopper" },
  { id: 7, title: "Yuka in her living room", year: "2025", style:"Van Gogh" },
  { id: 8, title: "Portrait of Anna", year: "2025" , style:"Van Gogh"},
  { id: 9, title: "Portrait of Irina", year: "2025", style:"Hopper" },
  { id: 10, title: "Portrait of Natalia", year: "2025" , style:"Impressionism"},
  { id: 11, title: "Karate Cub", year: "2025", style:"Hopper" },
  { id: 12, title: "Magic Mountain", year: "2025", style:"Impressionism" },
];

function GalleryImage({ num, title, year, style }) {
  const formats = ['png', 'jpg', 'jpeg', 'tiff'];
  const [formatIndex, setFormatIndex] = useState(0);
  const [failed, setFailed] = useState(false);

  const handleError = (e) => {
    if (formatIndex < formats.length - 1) {
      setFormatIndex(formatIndex + 1);
    } else {
      setFailed(true);
      // Fallback SVG with specific title
      e.target.src = `data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="400" height="400" viewBox="0 0 400 400"><rect width="100%" height="100%" fill="%23E8E8E6"/><text x="50%" y="50%" font-family="serif" font-size="20" fill="%232C2C2C" text-anchor="middle" dominant-baseline="middle">${title}</text></svg>`;
    }
  };

  return (
    <div className="group flex flex-col items-start w-full">

      {/* The Image Frame */}
      <div className="relative w-full aspect-square overflow-hidden bg-stone-100 mb-6 cursor-pointer">
        <img
          src={failed ? undefined : `/gallery_image_${num}.${formats[formatIndex]}`}
          alt={title}
          className="w-full h-full object-cover transition-transform duration-[1.5s] ease-in-out group-hover:scale-105"
          onError={handleError}
        />
        {/* Subtle dark overlay on hover */}
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/5 transition-colors duration-500 pointer-events-none" />
      </div>

      {/* The Unique Museum Label */}
      <div className="flex flex-col items-start w-full pl-1">

        {/* Title - Bold and Serif */}
        <h3 className="font-serif text-lg text-stone-900 italic font-medium leading-tight group-hover:text-stone-600 transition-colors">
          {title}
        </h3>

        {/* Details Line - Smaller Sans-Serif */}
        <div className="flex items-center gap-2 mt-2 text-xs font-sans tracking-widest text-stone-400 uppercase">
          <span>{year}</span>
          <span className="w-1 h-1 bg-stone-300 rounded-full"></span>
          <span>{style}</span>
        </div>
      </div>

    </div>
  );
}

function HomePage() {
  return (
    <div className="min-h-screen bg-[#F9F9F7] text-stone-900 flex flex-col items-center py-24 font-serif">

      {/* --- HEADER SECTION --- */}
      <div className="text-center mb-24 w-full px-6">

        {/* 1. Main Title */}
        <h1 className="text-6xl md:text-8xl font-medium tracking-tight text-stone-900 mb-10">
          Museome
        </h1>

        {/* 2. The New "About" Section */}
        {/* Styled like a museum exhibition text wall */}
        <div className="max-w-2xl mx-auto mb-16">
            <p className="font-serif text-lg md:text-xl leading-relaxed text-stone-600 font-light">
                synthesizes classical artistry with technology to transform your personal photographs into timeless masterpieces.
                Enjoy our Gallery or start creating in our Atelier.
            </p>
        </div>

        {/* 3. The Section Divider / Label */}
        <div className="flex flex-col items-center gap-6">
             <p className="text-xs font-sans tracking-[0.4em] text-stone-400 uppercase">
                Selected works from 2025
            </p>
        </div>

      </div>

      {/* --- THE GRID --- */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-16 gap-y-24 max-w-[90rem] px-6 w-full">
        {artworks.map((art) => (
          <GalleryImage
            key={art.id}
            num={art.id}
            title={art.title}
            year={art.year}
            style={art.style}
          />
        ))}
      </div>

      {/* Footer */}
      <div className="mt-40 mb-10 text-stone-300 text-xs tracking-widest uppercase">
        Powered by FACULTRA
      </div>

    </div>
  );
}

export default HomePage;